<ul class="taxes" tabindex="-1" id="infobulle-frais-propriété">
  <li class="municipal-taxes">
    <span class="label" [innerText]="'propriete.detail.frais.tiroir.taxes.municipales' | translate"></span>
    <app-currency-string
      class="taxes-amount"
      [value]="propriete.montantTaxesMunicipales"
      [periodicity]="'general.par-annee' | translate"
      [id]="'municipal-taxes'"
    ></app-currency-string>
  </li>
  <li class="school-taxes">
    <span class="label" [innerText]="'propriete.detail.frais.tiroir.taxes.scolaires' | translate"></span>
    <app-currency-string
      class="taxes-amount"
      [value]="propriete.montantTaxesScolaires"
      [periodicity]="'general.par-annee' | translate"
      [id]="'school-taxes'"
    ></app-currency-string>
  </li>
  <li class="energy-taxes">
    <span class="label" [innerText]="'propriete.detail.frais.tiroir.taxes.energie' | translate"></span>
    <app-currency-string
      class="taxes-amount"
      [value]="propriete.montantCoutEnergie"
      [periodicity]="'general.par-mois' | translate"
      [id]="'energy-taxes'"
    ></app-currency-string>
  </li>
</ul>
